function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWinner = function SvgWinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 1.333 1.333"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1.333v1.333H0z",
    style: {
      fill: "#69be7a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.28.28h.186l.327.47H.607z",
    style: {
      fill: "#733232"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.302.28h.142l.248.358H.55z",
    style: {
      fill: "#dc322f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.035.28H.848L.522.75h.186z",
    style: {
      fill: "#733232"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.013.28H.87L.623.638h.141z",
    style: {
      fill: "#dc322f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.912.791a.25.25 0 1 1-.502 0 .25.25 0 0 1 .502 0",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.845.79a.184.184 0 1 1-.368 0 .184.184 0 0 1 .368 0",
    style: {
      fill: "#facb1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.363.87a.09.09 0 0 1-.09.091.09.09 0 0 1 .09.09.09.09 0 0 1 .09-.09.09.09 0 0 1-.09-.09m.09.09h.002zm-.091.09v.002zm-.09-.09H.27zM.97.5a.09.09 0 0 1-.09.09.09.09 0 0 1 .09.091.09.09 0 0 1 .09-.09A.09.09 0 0 1 .97.5m.09.09h.002zM.97.68v.002zM.88.591H.878z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.69.926H.64v-.22L.606.693V.657h.045q.024 0 .032.009Q.69.675.69.702z",
    style: {
      fill: "#f99134"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.85.627C.772.7.56.917.497.98A.25.25 0 0 0 .85.627",
    style: {
      fill: "#f99134",
      opacity: 0.4
    }
  }));
};
export default SvgWinner;